var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoPlay = function SvgIcoPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 40,
    fill: "#eee",
    viewBox: "0 0 36 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M32.692 24.413a5.14 5.14 0 0 0 1.796-1.882 5.21 5.21 0 0 0 0-5.062 5.14 5.14 0 0 0-1.796-1.882L8.624.754a5.07 5.07 0 0 0-5.16-.092 5.14 5.14 0 0 0-1.907 1.895 5.2 5.2 0 0 0-.7 2.61v29.666c0 .918.242 1.818.7 2.61a5.14 5.14 0 0 0 1.907 1.895 5.07 5.07 0 0 0 5.16-.092z",
    clipRule: "evenodd"
  })));
};
export default SvgIcoPlay;